import { VentasPolicy } from "./VentasPolicy";

export const ventasPolicy = new VentasPolicy()